module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previosMaintain
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Container Condition")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.delaySurveyStatus == '1' || (_vm.designation == 'manager' && _vm.departmentName == 'Yard' && _vm.ContainerDetail.maintenanceRequest != '')) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "65"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Reason For Delay Survey")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "delayReason",
      "name": "delayReason",
      "disabled": (_vm.designation == 'manager' && _vm.departmentName == 'Yard' || _vm.ContainerDetail.maintenanceRequest != '') ? true : false
    },
    model: {
      value: (_vm.ContainerDetail.delayReason),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "delayReason", $$v)
      },
      expression: "ContainerDetail.delayReason"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.designation != 'manager' && _vm.departmentName == 'Yard') ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "addButtonLoader3",
      "disabled": _vm.ContainerDetail.maintenanceRequest != '' ? true : false
    },
    on: {
      "click": function($event) {
        _vm.requestForMaintain('employee')
      }
    }
  }, [_vm._v("Request For Survey")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader3"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.designation == 'manager' && _vm.departmentName == 'Yard' && (_vm.delaySurveyStatus == '1' || _vm.ContainerDetail.maintenanceRequest != '')) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenanceRequest"
    }
  }, [_vm._v("Maintenance Approval Request")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.maintenanceRequestList,
      "option-value": "maintenanceRequestV",
      "option-text": "maintenanceRequestT",
      "placeholder": "Select As Required",
      "isDisabled": _vm.designation == 'manager' && _vm.departmentName == 'Yard' && _vm.delaySurveyStatus == '1' ? false : true
    },
    model: {
      value: (_vm.ContainerDetail.maintenanceRequest),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "maintenanceRequest", $$v)
      },
      expression: "ContainerDetail.maintenanceRequest"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [(_vm.designation == 'manager' && _vm.departmentName == 'Yard' && _vm.delaySurveyStatus == '1') ? _c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "id": "addButtonLoader3"
    },
    on: {
      "click": function($event) {
        _vm.requestForMaintain('manager')
      }
    }
  }, [_vm._v("Approve")]) : _vm._e(), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader3"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: " gutr"
  }, [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-info",
      "size": "sm",
      "disabled": _vm.permissionStatus ? true : false
    },
    on: {
      "click": _vm.showMoreContainer
    }
  }, [_vm._v(_vm._s(_vm.showMoreNew == true ? "Hide" : "Show") + " Container Details")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1), _vm._v(" "), (_vm.showMoreNew == true) ? _c('md-layout', {
    staticClass: "marg-top gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Container Details:")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showMoreNew == true) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Size/Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerTypeId",
      "name": "containerTypeId",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.containerTypeId),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "containerTypeId", $$v)
      },
      expression: "ContainerDetail.containerTypeId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Gross Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grossWeight",
      "name": "grossWeight",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.grossWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "grossWeight", $$v)
      },
      expression: "ContainerDetail.grossWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Tare Wgt.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "tareWeight",
      "name": "tareWeight",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.tareWeight),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "tareWeight", $$v)
      },
      expression: "ContainerDetail.tareWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Manufacturing Month-Year")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "manufractureYear",
      "name": "manufractureYear",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.manufractureYear),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "manufractureYear", $$v)
      },
      expression: "ContainerDetail.manufractureYear"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showMoreNew == true) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerNo",
      "name": "containerNo",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "containerNo", $$v)
      },
      expression: "ContainerDetail.containerNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vehicle No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vehicleNo",
      "name": "vehicleNo",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.vehicleNo),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "vehicleNo", $$v)
      },
      expression: "ContainerDetail.vehicleNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Transport Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "transportName",
      "name": "transportName",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.transportName),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "transportName", $$v)
      },
      expression: "ContainerDetail.transportName"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.delaySurveyStatus != '1') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "repairStatus"
    }
  }, [_vm._v("Repair Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "repairStatusV",
      "option-text": "repairStatusT",
      "list": _vm.repairStatusList,
      "placeholder": "Select Repair Status ",
      "isDisabled": _vm.ContainerDetail.estimationAmount != '' ? true : false
    },
    model: {
      value: (_vm.ContainerDetail.repairStatus),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "repairStatus", $$v)
      },
      expression: "ContainerDetail.repairStatus"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "uploadboe",
      "id": "boe",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBoe('uploadRepair')
      }
    },
    model: {
      value: (_vm.ContainerDetail.uploadRepair),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "uploadRepair", $$v)
      },
      expression: "ContainerDetail.uploadRepair"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Survey Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "surveyDate"
    },
    model: {
      value: (_vm.ContainerDetail.surveyDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "surveyDate", $$v)
      },
      expression: "ContainerDetail.surveyDate"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.firstBlUploadView2.length > 0) ? _c('md-layout', {
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _vm._l((_vm.firstBlUploadView2), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "5"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/containerCondition/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("File - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.repairStatus == 'Required' && _vm.approvedAlready != 'Approved') ? _c('b-container', {
    staticClass: "gutr"
  }, [_c('b-card', [(_vm.ContainerDetail.repairStatus == 'Required' && _vm.approvedAlready != 'Approved') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('label', {
    attrs: {
      "for": "repairId"
    }
  }, [_vm._v("Repair Condition")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "repairId",
      "option-text": "repairCondition",
      "list": _vm.mainRepairList,
      "placeholder": "Select Repair Condition",
      "isDisabled": _vm.subContainer.updateConditionId != '' ? true : false
    },
    model: {
      value: (_vm.subContainer.repairId),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "repairId", $$v)
      },
      expression: "subContainer.repairId"
    }
  }), _vm._v(" "), (!_vm.subContainer.repairId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerConditionError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', {
    attrs: {
      "for": "repairSideId"
    }
  }, [_vm._v("Repair Side-Condition")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "repairSideId",
      "option-text": "repairSideName",
      "list": _vm.sideRepairList,
      "placeholder": "Select Side-Condition",
      "isDisabled": _vm.subContainer.repairId == '' ? true : false
    },
    model: {
      value: (_vm.subContainer.repairSideId),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "repairSideId", $$v)
      },
      expression: "subContainer.repairSideId"
    }
  }), _vm._v(" "), (!_vm.subContainer.repairSideId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.repairSideIdError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.repairStatus == 'Required' && _vm.approvedAlready != 'Approved') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('label', {
    attrs: {
      "for": "repairSubId"
    }
  }, [_vm._v("Repair Sub-Condition")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "repairSubId",
      "option-text": "repairSubName",
      "list": _vm.subRepairList,
      "placeholder": "Select Sub-Condition",
      "isDisabled": _vm.subContainer.repairSideId == '' ? true : false
    },
    model: {
      value: (_vm.subContainer.repairSubId),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "repairSubId", $$v)
      },
      expression: "subContainer.repairSubId"
    }
  }), _vm._v(" "), (!_vm.subContainer.repairSubId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.subConditionError))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.repairStatus == 'Required' && _vm.approvedAlready != 'Approved') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('label', {
    attrs: {
      "for": "subContainerCondition"
    }
  }, [_vm._v("Remark")]), _vm._v(" "), _c('b-textarea', {
    attrs: {
      "disabled": _vm.subContainer.updateConditionId != '' ? true : false
    },
    model: {
      value: (_vm.subContainer.containerRemark),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "containerRemark", $$v)
      },
      expression: "subContainer.containerRemark"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.designation == 'manager' && _vm.subContainer.updateConditionId != '') ? _c('div', [((_vm.delaySurveyStatus == '' || _vm.designation == 'manager') && _vm.ContainerDetail.repairStatus == 'Required') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.designation == 'manager') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.designation == 'manager') ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "id": "materialCost",
      "name": "materialCost"
    },
    model: {
      value: (_vm.subContainer.materialCost),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "materialCost", $$v)
      },
      expression: "subContainer.materialCost"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Repair Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "shippingApprovalV",
      "option-text": "shippingApprovalT",
      "list": _vm.shippingApprovalList,
      "placeholder": "Select Approval Status"
    },
    model: {
      value: (_vm.subContainer.status),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "status", $$v)
      },
      expression: "subContainer.status"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Approval Amount")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "id": "approvalAmount",
      "name": "approvalAmount"
    },
    model: {
      value: (_vm.subContainer.approvalAmount),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "approvalAmount", $$v)
      },
      expression: "subContainer.approvalAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Repair Remark")]), _vm._v(" "), _c('b-textarea', {
    model: {
      value: (_vm.subContainer.managerRemark),
      callback: function($$v) {
        _vm.$set(_vm.subContainer, "managerRemark", $$v)
      },
      expression: "subContainer.managerRemark"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ContainerDetail.repairStatus == 'Required' && _vm.approvedAlready != 'Approved') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm"
    },
    on: {
      "click": _vm.updateContainerCondition
    }
  }, [_vm._v(_vm._s(_vm.subContainer.updateConditionId != "" ? "Edit" : "Add"))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.subConditionArray.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "box-title"
  }, [_vm._v("\n                    Container No.\n                    "), _c('u', [_vm._v(_vm._s(this.ContainerDetail.containerNo))]), _vm._v(" Details\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "tariff"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Repair Condition")]), _vm._v(" "), _c('th', [_vm._v("Repair Side-Condition")]), _vm._v(" "), _c('th', [_vm._v("Repair Sub-Condition")]), _vm._v(" "), _c('th', [_vm._v("Remark")]), _vm._v(" "), (_vm.designation == 'manager') ? _c('th', [_vm._v("Amount")]) : _vm._e(), _vm._v(" "), (_vm.designation == 'manager') ? _c('th', [_vm._v("Approval Amount")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), (_vm.ContainerDetail.shippingApproval != 'Approved') ? _c('th', [_vm._v("Delete")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_c('tr'), _vm._v(" "), _vm._l((_vm.subConditionArray), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.editContainer1(item)
        }
      }
    }, [_vm._v(_vm._s(item.repairCondition))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.repairSideName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.repairSubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerRemark))]), _vm._v(" "), (_vm.designation == 'manager') ? _c('th', [_vm._v(_vm._s(item.materialCost))]) : _vm._e(), _vm._v(" "), (_vm.designation == 'manager') ? _c('th', [_vm._v(_vm._s(item.approvalAmount))]) : _vm._e(), _vm._v(" "), _c('td', {
      style: (item.status == 'Approved' ? 'color:green' : 'color:red')
    }, [_vm._v(_vm._s(item.status == '' ? "Sent For Approval" : item.status))]), _vm._v(" "), (_vm.ContainerDetail.shippingApproval != 'Approved') ? _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.deleteData(item.updateConditionId)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1) : _vm._e()])
  })], 2)])])]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.designation == 'manager') ? _c('div', [((_vm.delaySurveyStatus == '' || _vm.designation == 'manager') && _vm.ContainerDetail.repairStatus == 'Required') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.designation == 'manager') ? _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.designation == 'manager') ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Estimation Amount")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "estimationAmount",
      "name": "estimationAmount",
      "disabled": ""
    },
    model: {
      value: (_vm.ContainerDetail.estimationAmount),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "estimationAmount", $$v)
      },
      expression: "ContainerDetail.estimationAmount"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.estimationAmount) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.estimationAmountError))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Estimation Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "estimationDate"
    },
    model: {
      value: (_vm.ContainerDetail.estimationDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "estimationDate", $$v)
      },
      expression: "ContainerDetail.estimationDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Approval Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "shippingApprovalV",
      "option-text": "shippingApprovalT",
      "list": _vm.shippingApprovalList,
      "isDisabled": _vm.approvedAlready == 'Approved' ? true : false,
      "placeholder": "Select Approval Status"
    },
    model: {
      value: (_vm.ContainerDetail.shippingApproval),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "shippingApproval", $$v)
      },
      expression: "ContainerDetail.shippingApproval"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Approval Amount")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "id": "approvalAmount",
      "name": "approvalAmount",
      "disabled": _vm.approvedAlready == 'Approved' ? true : false
    },
    model: {
      value: (_vm.ContainerDetail.approvalAmount),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "approvalAmount", $$v)
      },
      expression: "ContainerDetail.approvalAmount"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Approved Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "disabled": _vm.permissionStatus,
      "id": "Date"
    },
    model: {
      value: (_vm.ContainerDetail.approvedDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "approvedDate", $$v)
      },
      expression: "ContainerDetail.approvedDate"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.designation == 'surveyer' && _vm.approvedAlready == 'Approved') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "repairCompletedNot"
    }
  }, [_vm._v("Repair Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "option-value": "repairCompletedNotV",
      "option-text": "repairCompletedNotT",
      "list": _vm.repairCompletedNotList,
      "placeholder": "Select Repair Status"
    },
    model: {
      value: (_vm.ContainerDetail.repairCompletedNot),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "repairCompletedNot", $$v)
      },
      expression: "ContainerDetail.repairCompletedNot"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Repair Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "Date"
    },
    model: {
      value: (_vm.ContainerDetail.repairDate),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "repairDate", $$v)
      },
      expression: "ContainerDetail.repairDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ContainerDetail.repairCompletedNot == 'Repair_Done') ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "uploadboe",
      "id": "boe",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBoe('uploadRepairDone')
      }
    },
    model: {
      value: (_vm.ContainerDetail.uploadRepairDone),
      callback: function($$v) {
        _vm.$set(_vm.ContainerDetail, "uploadRepairDone", $$v)
      },
      expression: "ContainerDetail.uploadRepairDone"
    }
  })], 1), _vm._v(" "), (!_vm.ContainerDetail.uploadRepairDone) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.uploadFileError))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.firstBlUploadView.length > 0 && _vm.ContainerDetail.repairCompletedNot == 'Repair_Done' && _vm.designation == 'surveyer' && _vm.approvedAlready == 'Approved') ? _c('md-layout', {
    staticStyle: {
      "margin-top": "1%"
    },
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }), _vm._v(" "), _vm._l((_vm.firstBlUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "5"
      }
    }, [_c('a', {
      attrs: {
        "href": (this.docURL) + "/containerCondition/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("File - " + _vm._s(index + 1))])])
  })], 2) : _vm._e(), _vm._v(" "), ((_vm.ContainerDetail.delaySurveyStatus != '1') || _vm.ContainerDetail.repairStatus == 'Not_Required') ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.UpdateSurvey
    }
  }, [_vm._v("Submit")])], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopSub",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopSubCon",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose1
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22222",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22222
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop110",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose110
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332fb849","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/yard/editContainerRepair.vue
// module id = 2508
// module chunks = 0